function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 94"
}, props), React.createElement("path", {
  d: "M31.702 77.316c7.073 2.69 13.116 2.662 17.684 1.837 10.528-1.901 14.139-14.175 14.62-23.38 1.343-25.451-16.748-37.998-16.748-37.998l2.454-3.113S87.31 37.137 78.48 71.39c0 0-9.328 25.301-39.156 13.802l-7.622-7.884v.007z",
  fill: "#95CEE1"
}), React.createElement("path", {
  d: "M31.68 21.505c4.374.567 8.979.646 12.923-1.6 1.935-1.097 3.514-2.747 4.263-4.792.668-1.8.63-3.55.2-5.193C47.822 5.207 43.284 2 38.257 2H27.661M31.146 75.981c4.746 12.985 25.454 16.794 39.008 7.045 8.311-5.976 10.75-16.47 9.564-26.055-1.964-15.796-10.64-30.746-30.25-41.908",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M4.877 80.895c9.646 3.092 22.696 5.044 31.437 2.246",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M2 3.485c9.572 23.35 9.646 44.592 5.012 67.375-1.157 5.682-3.826 12.877-1.216 18.092 0 0 25.335 7.704 39.497-1.385M74.988 63.456V61.19",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M42.105 12.072a.635.635 0 00-.645-.624.635.635 0 00-.645.624c0 .344.289.624.645.624.355 0 .645-.28.645-.624z",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinejoin: "round"
})));